module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-left-2b3dfea0e5dd3334761966fd250ffc94.svg";